export class ArtistDetailModel {
    public id: number;
    public name: string;
    public bio: string;
    public pressShot: string;
    public pressShotUrl: string;
    public createdOn: string;
    public websiteUrl: string;
    public facebookUrl: string;
    public twitterUrl: string;
    public instagramUrl: string;
    public youTubeUrl: string;
    public linkedInUrl: string;
}



// WEBPACK FOOTER //
// ./src/models/artist/artist.detail.model.ts